export default "__VITE_ASSET__OyVClyBh__"